import React from 'react';
import { LogoTPE } from './logoTPE';

export const LogoComponent = ({ height, width, className, prospectExchangeAccount, isLightLogo }) => {
    if (prospectExchangeAccount) {
        return null;
    }

    return <LogoTPE height={height} width={width} classname={className} isLightLogo={isLightLogo} />;
};
